// extracted by mini-css-extract-plugin
export default {"container":"ReadingOrderOverlay_container__p6jns","svgContainer":"ReadingOrderOverlay_svgContainer__sC1P+"};